import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/home/index.vue'
import NewsDetail from '@/views/newsDetail/index.vue'
import NewsList from '@/views/newsList/index.vue'
import PageDetail from '@/views/pageDetail/index.vue'
import ArticleList from '@/views/articleList/index.vue'
import ArticleDetail from '@/views/articleDetail/index.vue'
import PageIdDetail from '@/views/pageIdDetail/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/news/:id',
    name: 'NewsDetail',
    component: NewsDetail
  },
  {
    path: '/news-list',
    name: 'NewsList',
    component: NewsList
  },
  // 新增页面详情路由
  {
    path: '/page/:code',
    name: 'PageDetail',
    component: PageDetail
  },
  // 新增文章列表路由
  {
    path: '/article/:category',
    name: 'ArticleList',
    component: ArticleList
  },
  // 新增文章详情路由
  {
    path: '/article/detail/:id',
    name: 'ArticleDetail',
    component: ArticleDetail
  },
  // 页面详情（按id）
  {
    path: '/page/detail/:id',
    name: 'PageIdDetail',
    component: PageIdDetail
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

export default router
